module.exports = LEECHONGWEI_RANKING = [
{"date": "2009-10-08", "worldRanking": 1},
{"date": "2009-10-15", "worldRanking": 1},
{"date": "2009-10-22", "worldRanking": 1},
{"date": "2009-10-29", "worldRanking": 1},
{"date": "2009-11-05", "worldRanking": 1},
{"date": "2009-11-12", "worldRanking": 1},
{"date": "2009-11-19", "worldRanking": 1},
{"date": "2009-11-26", "worldRanking": 1},
{"date": "2009-12-03", "worldRanking": 1},
{"date": "2009-12-10", "worldRanking": 1},
{"date": "2009-12-17", "worldRanking": 1},
{"date": "2009-12-24", "worldRanking": 1},
{"date": "2009-12-31", "worldRanking": 1},
{"date": "2010-01-07", "worldRanking": 1},
{"date": "2010-01-14", "worldRanking": 1},
{"date": "2010-01-21", "worldRanking": 1},
{"date": "2010-01-28", "worldRanking": 1},
{"date": "2010-02-04", "worldRanking": 1},
{"date": "2010-02-11", "worldRanking": 1},
{"date": "2010-03-11", "worldRanking": 1},
{"date": "2010-03-18", "worldRanking": 1},
{"date": "2010-03-25", "worldRanking": 1},
{"date": "2010-04-01", "worldRanking": 1},
{"date": "2010-04-08", "worldRanking": 1},
{"date": "2010-04-15", "worldRanking": 1},
{"date": "2010-04-22", "worldRanking": 1},
{"date": "2010-04-29", "worldRanking": 1},
{"date": "2010-05-06", "worldRanking": 1},
{"date": "2010-05-13", "worldRanking": 1},
{"date": "2010-05-20", "worldRanking": 1},
{"date": "2010-05-27", "worldRanking": 1},
{"date": "2010-06-03", "worldRanking": 1},
{"date": "2010-06-10", "worldRanking": 1},
{"date": "2010-06-17", "worldRanking": 1},
{"date": "2010-06-24", "worldRanking": 1},
{"date": "2010-07-01", "worldRanking": 1},
{"date": "2010-07-08", "worldRanking": 1},
{"date": "2010-07-15", "worldRanking": 1},
{"date": "2010-07-22", "worldRanking": 1},
{"date": "2010-07-29", "worldRanking": 1},
{"date": "2010-08-05", "worldRanking": 1},
{"date": "2010-08-12", "worldRanking": 1},
{"date": "2010-08-19", "worldRanking": 1},
{"date": "2010-08-26", "worldRanking": 1},
{"date": "2010-09-02", "worldRanking": 1},
{"date": "2010-09-09", "worldRanking": 1},
{"date": "2010-09-16", "worldRanking": 1},
{"date": "2010-09-23", "worldRanking": 1},
{"date": "2010-09-30", "worldRanking": 1},
{"date": "2010-10-07", "worldRanking": 1},
{"date": "2010-10-14", "worldRanking": 1},
{"date": "2010-10-21", "worldRanking": 1},
{"date": "2010-10-28", "worldRanking": 1},
{"date": "2010-11-04", "worldRanking": 1},
{"date": "2010-11-11", "worldRanking": 1},
{"date": "2010-11-18", "worldRanking": 1},
{"date": "2010-11-25", "worldRanking": 1},
{"date": "2010-12-02", "worldRanking": 1},
{"date": "2010-12-09", "worldRanking": 1},
{"date": "2010-12-16", "worldRanking": 1},
{"date": "2010-12-23", "worldRanking": 1},
{"date": "2010-12-30", "worldRanking": 1},
{"date": "2011-01-06", "worldRanking": 1},
{"date": "2011-01-13", "worldRanking": 1},
{"date": "2011-01-20", "worldRanking": 1},
{"date": "2011-01-27", "worldRanking": 1},
{"date": "2011-02-03", "worldRanking": 1},
{"date": "2011-02-10", "worldRanking": 1},
{"date": "2011-02-17", "worldRanking": 1},
{"date": "2011-02-24", "worldRanking": 1},
{"date": "2011-03-03", "worldRanking": 1},
{"date": "2011-03-10", "worldRanking": 1},
{"date": "2011-03-17", "worldRanking": 1},
{"date": "2011-03-24", "worldRanking": 1},
{"date": "2011-03-31", "worldRanking": 1},
{"date": "2011-04-07", "worldRanking": 1},
{"date": "2011-04-14", "worldRanking": 1},
{"date": "2011-04-21", "worldRanking": 1},
{"date": "2011-04-28", "worldRanking": 1},
{"date": "2011-05-05", "worldRanking": 1},
{"date": "2011-05-12", "worldRanking": 1},
{"date": "2011-05-19", "worldRanking": 1},
{"date": "2011-05-26", "worldRanking": 1},
{"date": "2011-06-02", "worldRanking": 1},
{"date": "2011-06-09", "worldRanking": 1},
{"date": "2011-06-16", "worldRanking": 1},
{"date": "2011-06-23", "worldRanking": 1},
{"date": "2011-06-30", "worldRanking": 1},
{"date": "2011-07-07", "worldRanking": 1},
{"date": "2011-07-14", "worldRanking": 1},
{"date": "2011-07-21", "worldRanking": 1},
{"date": "2011-07-28", "worldRanking": 1},
{"date": "2011-08-04", "worldRanking": 1},
{"date": "2011-08-11", "worldRanking": 1},
{"date": "2011-08-18", "worldRanking": 1},
{"date": "2011-08-25", "worldRanking": 1},
{"date": "2011-09-02", "worldRanking": 1},
{"date": "2011-09-08", "worldRanking": 1},
{"date": "2011-09-15", "worldRanking": 1},
{"date": "2011-09-22", "worldRanking": 1},
{"date": "2011-09-29", "worldRanking": 1},
{"date": "2011-10-06", "worldRanking": 1},
{"date": "2011-10-13", "worldRanking": 1},
{"date": "2011-10-20", "worldRanking": 1},
{"date": "2011-10-27", "worldRanking": 1},
{"date": "2011-11-03", "worldRanking": 1},
{"date": "2011-11-10", "worldRanking": 1},
{"date": "2011-11-17", "worldRanking": 1},
{"date": "2011-11-24", "worldRanking": 1},
{"date": "2011-12-01", "worldRanking": 1},
{"date": "2011-12-08", "worldRanking": 1},
{"date": "2011-12-15", "worldRanking": 1},
{"date": "2011-12-22", "worldRanking": 1},
{"date": "2011-12-29", "worldRanking": 1},
{"date": "2012-01-05", "worldRanking": 1},
{"date": "2012-01-12", "worldRanking": 1},
{"date": "2012-01-19", "worldRanking": 1},
{"date": "2012-01-26", "worldRanking": 1},
{"date": "2012-02-02", "worldRanking": 1},
{"date": "2012-02-09", "worldRanking": 1},
{"date": "2012-02-16", "worldRanking": 1},
{"date": "2012-02-23", "worldRanking": 1},
{"date": "2012-03-01", "worldRanking": 1},
{"date": "2012-03-08", "worldRanking": 1},
{"date": "2012-03-15", "worldRanking": 1},
{"date": "2012-03-22", "worldRanking": 1},
{"date": "2012-03-29", "worldRanking": 1},
{"date": "2012-04-05", "worldRanking": 1},
{"date": "2012-04-12", "worldRanking": 1},
{"date": "2012-04-19", "worldRanking": 1},
{"date": "2012-04-26", "worldRanking": 1},
{"date": "2012-05-03", "worldRanking": 1},
{"date": "2012-05-10", "worldRanking": 1},
{"date": "2012-05-17", "worldRanking": 1},
{"date": "2012-05-24", "worldRanking": 1},
{"date": "2012-05-31", "worldRanking": 1},
{"date": "2012-06-07", "worldRanking": 1},
{"date": "2012-06-14", "worldRanking": 1},
{"date": "2012-06-21", "worldRanking": 2},
{"date": "2012-06-28", "worldRanking": 2},
{"date": "2012-07-05", "worldRanking": 2},
{"date": "2012-07-12", "worldRanking": 2},
{"date": "2012-07-19", "worldRanking": 2},
{"date": "2012-07-26", "worldRanking": 2},
{"date": "2012-08-02", "worldRanking": 2},
{"date": "2012-08-09", "worldRanking": 2},
{"date": "2012-08-16", "worldRanking": 2},
{"date": "2012-08-23", "worldRanking": 2},
{"date": "2012-08-30", "worldRanking": 2},
{"date": "2012-09-06", "worldRanking": 2},
{"date": "2012-09-13", "worldRanking": 2},
{"date": "2012-09-20", "worldRanking": 2},
{"date": "2012-09-27", "worldRanking": 1},
{"date": "2012-10-04", "worldRanking": 1},
{"date": "2012-10-11", "worldRanking": 1},
{"date": "2012-10-18", "worldRanking": 1},
{"date": "2012-10-25", "worldRanking": 1},
{"date": "2012-11-01", "worldRanking": 1},
{"date": "2012-11-08", "worldRanking": 1},
{"date": "2012-11-16", "worldRanking": 1},
{"date": "2012-11-22", "worldRanking": 1},
{"date": "2012-11-29", "worldRanking": 1},
{"date": "2012-12-06", "worldRanking": 1},
{"date": "2012-12-13", "worldRanking": 1},
{"date": "2012-12-20", "worldRanking": 1},
{"date": "2012-12-27", "worldRanking": 1},
{"date": "2013-01-03", "worldRanking": 1},
{"date": "2013-01-10", "worldRanking": 1},
{"date": "2013-01-17", "worldRanking": 1},
{"date": "2013-01-25", "worldRanking": 1},
{"date": "2013-01-31", "worldRanking": 1},
{"date": "2013-02-07", "worldRanking": 1},
{"date": "2013-02-14", "worldRanking": 1},
{"date": "2013-02-21", "worldRanking": 1},
{"date": "2013-02-28", "worldRanking": 1},
{"date": "2013-03-07", "worldRanking": 1},
{"date": "2013-03-14", "worldRanking": 1},
{"date": "2013-03-21", "worldRanking": 1},
{"date": "2013-03-28", "worldRanking": 1},
{"date": "2013-04-04", "worldRanking": 1},
{"date": "2013-04-11", "worldRanking": 1},
{"date": "2013-04-18", "worldRanking": 1},
{"date": "2013-04-25", "worldRanking": 1},
{"date": "2013-05-02", "worldRanking": 1},
{"date": "2013-05-09", "worldRanking": 1},
{"date": "2013-05-16", "worldRanking": 1},
{"date": "2013-05-23", "worldRanking": 1},
{"date": "2013-05-30", "worldRanking": 1},
{"date": "2013-06-06", "worldRanking": 1},
{"date": "2013-06-13", "worldRanking": 1},
{"date": "2013-06-20", "worldRanking": 1},
{"date": "2013-06-27", "worldRanking": 1},
{"date": "2013-07-04", "worldRanking": 1},
{"date": "2013-07-11", "worldRanking": 1},
{"date": "2013-07-18", "worldRanking": 1},
{"date": "2013-07-25", "worldRanking": 1},
{"date": "2013-08-01", "worldRanking": 1},
{"date": "2013-08-07", "worldRanking": 1},
{"date": "2013-08-15", "worldRanking": 1},
{"date": "2013-08-22", "worldRanking": 1},
{"date": "2013-08-29", "worldRanking": 1},
{"date": "2013-09-05", "worldRanking": 1},
{"date": "2013-09-12", "worldRanking": 1},
{"date": "2013-09-19", "worldRanking": 1},
{"date": "2013-09-26", "worldRanking": 1},
{"date": "2013-10-03", "worldRanking": 1},
{"date": "2013-10-10", "worldRanking": 1},
{"date": "2013-10-17", "worldRanking": 1},
{"date": "2013-10-24", "worldRanking": 1},
{"date": "2013-10-31", "worldRanking": 1},
{"date": "2013-11-07", "worldRanking": 1},
{"date": "2013-11-14", "worldRanking": 1},
{"date": "2013-11-21", "worldRanking": 1},
{"date": "2013-11-28", "worldRanking": 1},
{"date": "2013-12-05", "worldRanking": 1},
{"date": "2013-12-12", "worldRanking": 1},
{"date": "2013-12-19", "worldRanking": 1},
{"date": "2013-12-26", "worldRanking": 1},
{"date": "2014-01-02", "worldRanking": 1},
{"date": "2014-01-09", "worldRanking": 1},
{"date": "2014-01-16", "worldRanking": 1},
{"date": "2014-01-23", "worldRanking": 1},
{"date": "2014-01-30", "worldRanking": 1},
{"date": "2014-02-06", "worldRanking": 1},
{"date": "2014-02-13", "worldRanking": 1},
{"date": "2014-02-20", "worldRanking": 1},
{"date": "2014-02-27", "worldRanking": 1},
{"date": "2014-03-06", "worldRanking": 1},
{"date": "2014-03-13", "worldRanking": 1},
{"date": "2014-03-20", "worldRanking": 1},
{"date": "2014-03-27", "worldRanking": 1},
{"date": "2014-04-03", "worldRanking": 1},
{"date": "2014-04-10", "worldRanking": 1},
{"date": "2014-04-17", "worldRanking": 1},
{"date": "2014-04-24", "worldRanking": 1},
{"date": "2014-05-02", "worldRanking": 1},
{"date": "2014-05-08", "worldRanking": 1},
{"date": "2014-05-15", "worldRanking": 1},
{"date": "2014-05-22", "worldRanking": 1},
{"date": "2014-05-29", "worldRanking": 1},
{"date": "2014-06-05", "worldRanking": 1},
{"date": "2014-06-12", "worldRanking": 1},
{"date": "2014-06-19", "worldRanking": 1},
{"date": "2014-06-26", "worldRanking": 1},
{"date": "2014-07-03", "worldRanking": 1},
{"date": "2014-07-10", "worldRanking": 1},
{"date": "2014-07-17", "worldRanking": 1},
{"date": "2014-07-24", "worldRanking": 1},
{"date": "2014-07-31", "worldRanking": 1},
{"date": "2014-08-07", "worldRanking": 1},
{"date": "2014-08-14", "worldRanking": 1},
{"date": "2014-08-21", "worldRanking": 1},
{"date": "2014-08-28", "worldRanking": 1},
{"date": "2014-09-04", "worldRanking": 1},
{"date": "2014-09-11", "worldRanking": 1},
{"date": "2014-09-18", "worldRanking": 1},
{"date": "2014-09-25", "worldRanking": 1},
{"date": "2014-10-02", "worldRanking": 1},
{"date": "2014-10-09", "worldRanking": 1},
{"date": "2014-10-16", "worldRanking": 1},
{"date": "2014-10-23", "worldRanking": 1},
{"date": "2014-10-30", "worldRanking": 1},
{"date": "2014-11-06", "worldRanking": 1},
{"date": "2014-11-13", "worldRanking": 1},
{"date": "2014-11-20", "worldRanking": 1},
{"date": "2014-11-27", "worldRanking": 1},
{"date": "2014-12-04", "worldRanking": 1},
{"date": "2014-12-11", "worldRanking": 1},
{"date": "2014-12-18", "worldRanking": 1},
{"date": "2014-12-24", "worldRanking": 2},
{"date": "2015-01-02", "worldRanking": 2},
{"date": "2015-01-08", "worldRanking": 2},
{"date": "2015-01-15", "worldRanking": 2},
{"date": "2015-01-22", "worldRanking": 3},
{"date": "2015-01-29", "worldRanking": 3},
{"date": "2015-02-05", "worldRanking": 3},
{"date": "2015-02-12", "worldRanking": 3},
{"date": "2015-02-18", "worldRanking": 3},
{"date": "2015-02-26", "worldRanking": 3},
{"date": "2015-03-05", "worldRanking": 3},
{"date": "2015-03-12", "worldRanking": 8},
{"date": "2015-03-19", "worldRanking": 8},
{"date": "2015-03-26", "worldRanking": 8},
{"date": "2015-04-02", "worldRanking": 16},
{"date": "2015-04-09", "worldRanking": 17},
{"date": "2015-04-16", "worldRanking": 30},
{"date": "2015-04-23", "worldRanking": 30},
{"date": "2015-04-30", "worldRanking": 45},
{"date": "2015-05-07", "worldRanking": 46},
{"date": "2015-05-14", "worldRanking": 46},
{"date": "2015-05-21", "worldRanking": 46},
{"date": "2015-05-28", "worldRanking": 47},
{"date": "2015-06-04", "worldRanking": 46},
{"date": "2015-06-11", "worldRanking": 79},
{"date": "2015-06-18", "worldRanking": 180},
{"date": "2015-06-25", "worldRanking": 99},
{"date": "2015-07-02", "worldRanking": 65},
{"date": "2015-07-09", "worldRanking": 65},
{"date": "2015-07-16", "worldRanking": 65},
{"date": "2015-07-23", "worldRanking": 46},
{"date": "2015-07-30", "worldRanking": 45},
{"date": "2015-08-06", "worldRanking": 45},
{"date": "2015-08-13", "worldRanking": 44},
{"date": "2015-08-20", "worldRanking": 28},
{"date": "2015-08-27", "worldRanking": 28},
{"date": "2015-09-03", "worldRanking": 28},
{"date": "2015-09-10", "worldRanking": 28},
{"date": "2015-09-17", "worldRanking": 23},
{"date": "2015-09-23", "worldRanking": 24},
{"date": "2015-10-01", "worldRanking": 24},
{"date": "2015-10-08", "worldRanking": 25},
{"date": "2015-10-15", "worldRanking": 25},
{"date": "2015-10-22", "worldRanking": 19},
{"date": "2015-10-29", "worldRanking": 10},
{"date": "2015-11-05", "worldRanking": 9},
{"date": "2015-11-12", "worldRanking": 9},
{"date": "2015-11-19", "worldRanking": 6},
{"date": "2015-11-26", "worldRanking": 3},
{"date": "2015-12-03", "worldRanking": 4},
{"date": "2015-12-10", "worldRanking": 4},
{"date": "2015-12-17", "worldRanking": 5},
{"date": "2015-12-23", "worldRanking": 5},
{"date": "2015-12-31", "worldRanking": 5},
{"date": "2016-01-07", "worldRanking": 5},
{"date": "2016-01-14", "worldRanking": 5},
{"date": "2016-01-21", "worldRanking": 5},
{"date": "2016-01-28", "worldRanking": 2},
{"date": "2016-02-04", "worldRanking": 2},
{"date": "2016-02-11", "worldRanking": 2},
{"date": "2016-02-18", "worldRanking": 2},
{"date": "2016-02-25", "worldRanking": 2},
{"date": "2016-03-03", "worldRanking": 2},
{"date": "2016-03-10", "worldRanking": 2},
{"date": "2016-03-17", "worldRanking": 3},
{"date": "2016-03-24", "worldRanking": 3},
{"date": "2016-03-31", "worldRanking": 3},
{"date": "2016-04-07", "worldRanking": 4},
{"date": "2016-04-14", "worldRanking": 2},
{"date": "2016-04-21", "worldRanking": 2},
{"date": "2016-04-28", "worldRanking": 2},
{"date": "2016-05-05", "worldRanking": 2},
{"date": "2016-05-12", "worldRanking": 2},
{"date": "2016-05-19", "worldRanking": 2},
{"date": "2016-05-26", "worldRanking": 2},
{"date": "2016-06-02", "worldRanking": 2},
{"date": "2016-06-09", "worldRanking": 1},
{"date": "2016-06-16", "worldRanking": 1},
{"date": "2016-06-23", "worldRanking": 1},
{"date": "2016-06-30", "worldRanking": 1},
{"date": "2016-07-08", "worldRanking": 1},
{"date": "2016-07-14", "worldRanking": 1},
{"date": "2016-07-21", "worldRanking": 1},
{"date": "2016-07-28", "worldRanking": 1},
{"date": "2016-08-04", "worldRanking": 1},
{"date": "2016-08-11", "worldRanking": 1},
{"date": "2016-08-18", "worldRanking": 1},
{"date": "2016-08-25", "worldRanking": 1},
{"date": "2016-09-01", "worldRanking": 1},
{"date": "2016-09-08", "worldRanking": 1},
{"date": "2016-09-15", "worldRanking": 1},
{"date": "2016-09-22", "worldRanking": 1},
{"date": "2016-09-29", "worldRanking": 1},
{"date": "2016-10-06", "worldRanking": 1},
{"date": "2016-10-13", "worldRanking": 1},
{"date": "2016-10-20", "worldRanking": 1},
{"date": "2016-10-27", "worldRanking": 1},
{"date": "2016-11-03", "worldRanking": 1},
{"date": "2016-11-10", "worldRanking": 1},
{"date": "2016-11-17", "worldRanking": 1},
{"date": "2016-11-24", "worldRanking": 1},
{"date": "2016-12-01", "worldRanking": 1},
{"date": "2016-12-08", "worldRanking": 1},
{"date": "2016-12-15", "worldRanking": 1},
{"date": "2016-12-22", "worldRanking": 1},
{"date": "2016-12-29", "worldRanking": 1},
{"date": "2017-01-05", "worldRanking": 1},
{"date": "2017-01-12", "worldRanking": 1},
{"date": "2017-01-19", "worldRanking": 1},
{"date": "2017-01-26", "worldRanking": 1},
{"date": "2017-02-02", "worldRanking": 1},
{"date": "2017-02-10", "worldRanking": 1},
{"date": "2017-02-16", "worldRanking": 1},
{"date": "2017-02-23", "worldRanking": 1},
{"date": "2017-03-02", "worldRanking": 1},
{"date": "2017-03-09", "worldRanking": 1},
{"date": "2017-03-16", "worldRanking": 1},
{"date": "2017-03-23", "worldRanking": 1},
{"date": "2017-03-30", "worldRanking": 1},
{"date": "2017-04-06", "worldRanking": 1},
{"date": "2017-04-13", "worldRanking": 1},
{"date": "2017-04-20", "worldRanking": 1},
{"date": "2017-04-27", "worldRanking": 1},
{"date": "2017-05-04", "worldRanking": 1},
{"date": "2017-05-11", "worldRanking": 1},
{"date": "2017-05-18", "worldRanking": 1},
{"date": "2017-05-25", "worldRanking": 2},
{"date": "2017-06-01", "worldRanking": 1},
{"date": "2017-06-08", "worldRanking": 3},
{"date": "2017-06-15", "worldRanking": 3},
{"date": "2017-06-22", "worldRanking": 2},
{"date": "2017-06-29", "worldRanking": 2},
{"date": "2017-07-06", "worldRanking": 2},
{"date": "2017-07-13", "worldRanking": 2},
{"date": "2017-07-20", "worldRanking": 2},
{"date": "2017-07-27", "worldRanking": 2},
{"date": "2017-08-03", "worldRanking": 2},
{"date": "2017-08-10", "worldRanking": 2},
{"date": "2017-08-17", "worldRanking": 2},
{"date": "2017-08-24", "worldRanking": 5},
{"date": "2017-08-30", "worldRanking": 7},
{"date": "2017-09-07", "worldRanking": 7},
{"date": "2017-09-14", "worldRanking": 7},
{"date": "2017-09-21", "worldRanking": 7},
{"date": "2017-09-28", "worldRanking": 7},
{"date": "2017-10-05", "worldRanking": 7},
{"date": "2017-10-12", "worldRanking": 7},
{"date": "2017-10-19", "worldRanking": 7},
{"date": "2017-10-26", "worldRanking": 8},
{"date": "2017-11-02", "worldRanking": 8},
{"date": "2017-11-09", "worldRanking": 7},
{"date": "2017-11-16", "worldRanking": 7},
{"date": "2017-11-23", "worldRanking": 6},
{"date": "2017-11-30", "worldRanking": 3},
{"date": "2017-12-07", "worldRanking": 2},
{"date": "2017-12-14", "worldRanking": 2},
{"date": "2017-12-21", "worldRanking": 2},
{"date": "2017-12-28", "worldRanking": 2},
{"date": "2018-01-04", "worldRanking": 2},
{"date": "2018-01-11", "worldRanking": 2},
{"date": "2018-01-18", "worldRanking": 2},
{"date": "2018-01-25", "worldRanking": 2, "worldTourRanking": 34},
{"date": "2018-02-02", "worldRanking": 2, "worldTourRanking": 48},
{"date": "2018-02-08", "worldRanking": 2, "worldTourRanking": 62},
{"date": "2018-02-15", "worldRanking": 2},
{"date": "2018-02-22", "worldRanking": 2},
{"date": "2018-03-01", "worldRanking": 2, "worldTourRanking": 72},
{"date": "2018-03-08", "worldRanking": 2},
{"date": "2018-03-15", "worldRanking": 5, "worldTourRanking": 76},
{"date": "2018-03-22", "worldRanking": 6, "worldTourRanking": 37},
{"date": "2018-03-29", "worldRanking": 6},
{"date": "2018-04-05", "worldRanking": 6, "worldTourRanking": 40},
{"date": "2018-04-12", "worldRanking": 7},
{"date": "2018-04-19", "worldRanking": 7, "worldTourRanking": 41},
{"date": "2018-04-26", "worldRanking": 7},
{"date": "2018-05-03", "worldRanking": 7},
{"date": "2018-05-10", "worldRanking": 7, "worldTourRanking": 43},
{"date": "2018-05-17", "worldRanking": 7, "worldTourRanking": 48},
{"date": "2018-05-24", "worldRanking": 7},
{"date": "2018-05-31", "worldRanking": 7},
{"date": "2018-06-07", "worldRanking": 7},
{"date": "2018-06-14", "worldRanking": 7},
{"date": "2018-06-21", "worldRanking": 6, "worldTourRanking": 51},
{"date": "2018-06-28", "worldRanking": 6, "worldTourRanking": 53},
{"date": "2018-07-05", "worldRanking": 4, "worldTourRanking": 19},
{"date": "2018-07-12", "worldRanking": 2, "worldTourRanking": 11},
{"date": "2018-07-19", "worldRanking": 2, "worldTourRanking": 13},
{"date": "2018-07-26", "worldRanking": 2, "worldTourRanking": 18},
{"date": "2018-08-02", "worldRanking": 2, "worldTourRanking": 18},
{"date": "2018-08-09", "worldRanking": 3},
{"date": "2018-08-16", "worldRanking": 3, "worldTourRanking": 18},
{"date": "2018-08-23", "worldRanking": 3},
{"date": "2018-08-30", "worldRanking": 3},
{"date": "2018-09-06", "worldRanking": 3, "worldTourRanking": 18},
{"date": "2018-09-13", "worldRanking": 3, "worldTourRanking": 18},
{"date": "2018-09-20", "worldRanking": 4, "worldTourRanking": 24},
{"date": "2018-09-27", "worldRanking": 5, "worldTourRanking": 30},
{"date": "2018-10-04", "worldRanking": 5, "worldTourRanking": 32},
{"date": "2018-10-11", "worldRanking": 5, "worldTourRanking": 33},
{"date": "2018-10-18", "worldRanking": 5, "worldTourRanking": 33},
{"date": "2018-10-25", "worldRanking": 7, "worldTourRanking": 36},
{"date": "2018-11-01", "worldRanking": 8, "worldTourRanking": 36},
{"date": "2018-11-08", "worldRanking": 8, "worldTourRanking": 41},
{"date": "2018-11-15", "worldRanking": 9, "worldTourRanking": 43},
{"date": "2018-11-22", "worldRanking": 14, "worldTourRanking": 43},
{"date": "2018-11-29", "worldRanking": 15, "worldTourRanking": 49},
{"date": "2018-12-06", "worldRanking": 15},
{"date": "2018-12-13", "worldRanking": 15},
{"date": "2018-12-20", "worldRanking": 28},
{"date": "2018-12-27", "worldRanking": 28},
{"date": "2019-01-02", "worldRanking": 28},
{"date": "2019-01-08", "worldRanking": 28},
{"date": "2019-01-15", "worldRanking": 29},
{"date": "2019-01-22", "worldRanking": 31},
{"date": "2019-01-29", "worldRanking": 31},
{"date": "2019-02-05", "worldRanking": 30},
{"date": "2019-02-12", "worldRanking": 31},
{"date": "2019-02-19", "worldRanking": 31},
{"date": "2019-02-26", "worldRanking": 30},
{"date": "2019-03-05", "worldRanking": 31},
{"date": "2019-03-12", "worldRanking": 41},
{"date": "2019-03-19", "worldRanking": 41},
{"date": "2019-03-26", "worldRanking": 41},
{"date": "2019-04-02", "worldRanking": 44},
{"date": "2019-04-09", "worldRanking": 77},
{"date": "2019-04-16", "worldRanking": 74},
{"date": "2019-04-23", "worldRanking": 73},
{"date": "2019-04-30", "worldRanking": 115},
{"date": "2019-05-07", "worldRanking": 113},
{"date": "2019-05-14", "worldRanking": 110},
{"date": "2019-05-21", "worldRanking": 110},
{"date": "2019-05-28", "worldRanking": 190},
{"date": "2019-06-04", "worldRanking": 190},
{"date": "2019-06-11", "worldRanking": 191}
]



//////////////////
// WEBPACK FOOTER
// ./static/js/leechongwei-ranking.js
// module id = gBQl
// module chunks = 1